<template>
    <div class="max-w-screen flex h-screen w-full">
        <aside
            v-if="showLayout"
            class="relative border-r"
            :class="appStore.sideMini ? 'lg:w-16' : 'lg:w-64'"
        >
            <button
                type="button"
                class="absolute -right-4 top-7 z-50 hidden h-7 lg:block"
                @click="appStore.sideMini = !appStore.sideMini"
            >
                <div class="w-fit rounded-full border bg-white p-0.5 shadow">
                    <SvgIcon
                        name="system-chevron-left"
                        class="size-5 text-muval-gray-2 transition"
                        :class="appStore.sideMini && 'rotate-180'"
                    />
                </div>
            </button>
            <NavigationController />
        </aside>
        <div class="flex w-0 flex-1 flex-col gap-y-4">
            <NewTopHeader
                v-if="showLayout"
                class="mx-auto -mb-1 px-4 lg:px-8"
                :class="fullWidthView ? 'max-w-full' : 'max-w-[1920px]'"
            />
            <main class="h-[calc(100vh-88px)] flex-1 overflow-auto pt-1">
                <div
                    class="mx-auto h-full max-w-[1920px] lg:px-8"
                    :class="fullWidthView ? 'max-w-full' : 'max-w-[1920px]'"
                >
                    <div
                        :class="{
                            'h-full': fullHeightView,
                            'pb-4 lg:pb-8': !fullHeightView,
                        }"
                    >
                        <slot />
                    </div>
                </div>
            </main>
        </div>
        <NotificationSlideOver
            v-if="userStore.isAuthenticated"
            class="z-40"
        />
        <ThemeManager />
    </div>
</template>
<script setup>
const userStore = useUserStore();
const route = useRoute();
const appStore = useAppStore();

const showLayout = computed(() => {
    return (
        userStore.isAuthenticated &&
        route.name !== 'Login' &&
        route.name !== 'Register' &&
        route.name !== 'Update your preferences'
    );
});

const fullWidthView = computed(() => {
    return route.meta?.fullWidth;
});

const fullHeightView = computed(() => {
    return route.meta?.fullHeight;
});
</script>
